import React, { useRef, useState, useEffect } from "react";
import "./SessionExpired.css";
import SAMLogo from "../icons/SAM-integrity-logo.svg";
import { Button } from "@progress/kendo-react-buttons";
import { Card } from "@progress/kendo-react-layout";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAuthChange } from "../redux/toolSelectSlice";

const SessionExpired = () => {
    const dispatch = useDispatch();
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const [SiteName, setSiteName] = useState("");
    const navigate = useNavigate();
    const locaton = useLocation();
    const from = locaton.state?.from?.path || "/";
    const [authChangeDone, setAuthChangeDone] = useState(false);

    useEffect(() => {
        var now = new Date();
        document.cookie = `rft=""; sameSite=strict ; expires=${now.toUTCString()}`;
        document.cookie = `ast=""; sameSite=strict; expires=${now.toUTCString()}`;
    }, []);
    useEffect(() => {
        if (authChangeDone) {
            dispatch(setAuthChange(true));
        }
    }, [authChangeDone]);

    useEffect(() => {
        if (!mapConfig) {
            setSiteName("Loading");
        } else {
            setSiteName(`${mapConfig.DisplayName}`);
        }
    }, [mapConfig]);
    const handleSubmit = async (e) => {
        navigate(from, { replace: true });
        setAuthChangeDone(true);
    };
    return (
        <>
            <div className="content sessionExpire">
                <img className="brand" src={SAMLogo} alt="SAM Logo"></img>
                <Card>
                    <header>
                        <img src={process.env.REACT_APP_SAM_LOGO_URL} alt="SAM Logo" />
                        <h1>Session Expired</h1>
                    </header>
                    <p style={{ padding: "10px", "text-align": "justify" }}>
                        We're sorry, but your session has expired and you have been logged
                        out. This may be due to your account being inactive for a period
                        of time, or due to a security measure to protect your account.
                        Please log in again to continue using our site. If the issue
                        continues, please contact your subscription provider for
                        assistance. If you have any other questions or concerns, please
                        don't hesitate to reach out to our support team.
                    </p>
                    <Button onClick={handleSubmit}>Return To Site</Button>

                    <div>&nbsp;</div>
                </Card>
            </div>
        </>
    );
};
export default SessionExpired;
